import { ApartmentRoundReport } from '../models/apartment-round.model';
import { PlaygroundCheckReport } from '../models/playground-check.model';

export const apartmentRoundTypes = [
  { name: 'pipes', items: ['pipe', 'faucet'] },
  { name: 'air', items: ['air'] },
  { name: 'heating', items: ['heating'] },
  { name: 'moisture', items: ['moisture'] },
  { name: 'electricity', items: ['electricity'] },
  { name: 'structure', items: ['structure', 'surface'] },
  { name: 'windows', items: ['balcony', 'window'] },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isApartmentRound = (object: any): object is ApartmentRoundReport => {
  if (object == null || typeof object === 'string') {
    return false;
  }
  return 'type' in object;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPlayground = (object: any): object is PlaygroundCheckReport => {
  if (object == null || typeof object === 'string') {
    return false;
  }
  return 'swings' in object;
};
